import { Stack, YStack, SizableText } from '@mythical/ui'
import { isIOS } from 'app/utils/constants'
import React from 'react'

import { IconLock } from '../primitive/Icon'
import LockModal from '../primitive/LockModal'
import { UnlockButton } from './UnlockButton'
import { UpgradeButton } from './UpgradeButton'

type ContentLockModalProps = {
  onUnlock: () => void
  id: string
  planLevel: number | 'free'
  canUnlock: boolean
}

const ContentUnlockModal = ({
  id,
  onUnlock,
  planLevel,
  canUnlock,
}: ContentLockModalProps) => {
  return (
    <YStack w="100%" position="absolute" borderRadius="$2" zIndex="$1">
      <Stack
        borderRadius="$2"
        pos="absolute"
        w="100%"
        h="100%"
        zIndex={100}
        bg="$secondary10"
        opacity={0.5}
      />
      <Stack
        $gtXs={{
          aspectRatio: 16 / 9,
        }}
        w="100%"
        zIndex={1000}
      >
        <LockModal flexGrow={1} id={id} onUnlock={onUnlock}>
          <YStack
            space="$4"
            jc="center"
            ai="center"
            animation="lazy"
            enterStyle={{ opacity: 0 }}
            opacity={1}
          >
            <Stack p="$3" bg="$secondary8" borderRadius="$2">
              <IconLock size={24} color="$primary6" />
            </Stack>
            {!isIOS && (
              <SizableText
                fontFamily="$heading"
                textTransform="uppercase"
                size="$7"
                color="$primary1"
                textAlign="center"
                fontWeight="500"
              >
                Upgrade to continue watching
              </SizableText>
            )}
            {!isIOS && (
              <SizableText
                textAlign="center"
                fontWeight="600"
                size="$3"
                color="$secondary5"
              >
                Instantly unlock this video and more Mythical Society content by
                upgrading your subscription
              </SizableText>
            )}
            {isIOS && (
              <SizableText
                fontFamily="$heading"
                textTransform="uppercase"
                size="$7"
                color="$primary1"
                textAlign="center"
                fontWeight="500"
              >
                You do not have the correct level of permissions to view this video in full
              </SizableText>
            )}
            {canUnlock && (
              <SizableText
                textAlign="center"
                fontWeight="600"
                size="$3"
                color="$secondary5"
              >
                You can use your monthly unlock to watch this video.
              </SizableText>
            )}

            {!isIOS && <UpgradeButton planLevel={planLevel} />}
            {canUnlock && <UnlockButton id={id} onUnlock={onUnlock} />}
          </YStack>
        </LockModal>
      </Stack>
    </YStack>
  )
}

export default ContentUnlockModal
